import React from 'react';
import { Rating } from 'components/rating/src/types';
import { Price } from 'src/types';
import { StoreInfoColumn } from '../../components/store-info-column';
import { trackShopLogoClick } from '../../tracking';

const PriceRowStoreInfoColumn: React.FC<IStoreInfoColumnProps> = props => {
  const { store, rating } = props;

  return (
    <>
      {store && (
        <div
          role="none"
          onClick={e => {
            trackShopLogoClick(store.id);
          }}
        >
          <StoreInfoColumn store={store} rating={rating} />
        </div>
      )}
    </>
  );
};

export default PriceRowStoreInfoColumn;

export interface IStoreInfoColumnProps {
  store: Price['store'];
  rating: Rating | undefined;
}
